import React from 'react';
import RevealBlock from '../components/RevealBlock';
import SectionIntro from '../components/SectionIntro';
import TrainingFocusCard from '../components/TrainingFocusCard';
import './TrainingPlanSection.css';

function TrainingPlanSection() {
  return (
    <RevealBlock className="ayro-section ayro-section--plan" aria-labelledby="plan-heading">
      <SectionIntro kicker="Your training plan" title="A plan built for your goals and baseline." headingId="plan-heading">
        Onboarding starts with a BOLT test. From your <strong>score and goals,</strong> Ayro builds a personalized plan
        of recovery and endurance sessions that adapt as you improve.
      </SectionIntro>
      <TrainingFocusCard />
    </RevealBlock>
  );
}

export default TrainingPlanSection;
